"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ButtonWrapperStyled = exports.ButtonStyled = exports.ButtonContainerStyled = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var Styles = _interopRequireWildcard(require("./style"));
var _ChevronDown = _interopRequireDefault(require("../Icon/Icons/ChevronDown"));
var _Select = _interopRequireDefault(require("../Select/Select"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const ButtonWrapperStyled = exports.ButtonWrapperStyled = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Button__ButtonWrapperStyled",
  componentId: "bufferapp-ui__sc-16m8s20-0"
})(["", ";", ";", ";"], Styles.ButtonWrapperBase, props => Styles[[props.type, props.disabled ? 'Disabled' : ''].join('')], props => props.fullWidth ? Styles.fullWidth : '');
const ButtonContainerStyled = exports.ButtonContainerStyled = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Button__ButtonContainerStyled",
  componentId: "bufferapp-ui__sc-16m8s20-1"
})(["", ";"], Styles.ButtonContainerBase);
const ButtonStyled = exports.ButtonStyled = /*#__PURE__*/_styledComponents.default.button.withConfig({
  displayName: "Button__ButtonStyled",
  componentId: "bufferapp-ui__sc-16m8s20-2"
})(["", ";", ";", ";", ";"], Styles.ButtonNestedBase, props => Styles[props.size], props => Styles[props.disabled ? 'disabled' : ''], props => props.fullWidth ? Styles.fullWidth : '');
const Loading = /*#__PURE__*/_styledComponents.default.img.withConfig({
  displayName: "Button__Loading",
  componentId: "bufferapp-ui__sc-16m8s20-3"
})(["width:24px;margin-left:10px;"]);
const VisuallyHiddenLabel = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "Button__VisuallyHiddenLabel",
  componentId: "bufferapp-ui__sc-16m8s20-4"
})(["position:absolute;overflow:hidden;clip:rect(0 0 0 0);height:1px;width:1px;margin:-1px;padding:0;border:0;"]);
const Button = _a => {
  var {
      disabled,
      onClick,
      type,
      size,
      label,
      isSplit,
      loading,
      icon,
      iconEnd,
      hasIconOnly,
      isSelect,
      items,
      selectPosition,
      onSelectClick,
      fullWidth,
      tooltip,
      buttonRef,
      hideSearch,
      textToLeft,
      className,
      children,
      onOpen
    } = _a,
    props = __rest(_a, ["disabled", "onClick", "type", "size", "label", "isSplit", "loading", "icon", "iconEnd", "hasIconOnly", "isSelect", "items", "selectPosition", "onSelectClick", "fullWidth", "tooltip", "buttonRef", "hideSearch", "textToLeft", "className", "children", "onOpen"]);
  return /*#__PURE__*/_react.default.createElement(ButtonWrapperStyled, {
    className: className,
    disabled: disabled,
    type: type,
    fullWidth: fullWidth,
    "$loading": loading
  }, /*#__PURE__*/_react.default.createElement(ButtonContainerStyled, null, /*#__PURE__*/_react.default.createElement(ButtonStyled, Object.assign({
    onClick: !disabled ? onClick : undefined,
    disabled: disabled,
    isSplit: isSplit,
    icon: icon,
    hasIconOnly: hasIconOnly,
    "data-tip": tooltip,
    ref: buttonRef,
    "aria-haspopup": "false",
    size: size,
    fullWidth: fullWidth,
    type: type
  }, props), !iconEnd && icon, hasIconOnly && /*#__PURE__*/_react.default.createElement(VisuallyHiddenLabel, null, label), !hasIconOnly && ( /*#__PURE__*/_react.default.createElement(Styles.ButtonLabel, {
    hasIcon: !!icon,
    iconEnd: !!iconEnd,
    dangerouslySetInnerHTML: {
      __html: label
    }
  })), iconEnd && icon, isSelect && (type === 'primary' || type === 'secondary') && ( /*#__PURE__*/_react.default.createElement(Styles.ButtonArrow, {
    textToLeft: textToLeft
  }, /*#__PURE__*/_react.default.createElement(_ChevronDown.default, {
    color: type === 'primary' ? 'white' : 'grayDark',
    size: size
  }))), loading && /*#__PURE__*/_react.default.createElement(Loading, {
    src: "./images/loading-gray.svg",
    alt: "loading"
  })), isSplit && (type === 'primary' || type === 'secondary') && (children ? _react.default.Children.map(children, child => /*#__PURE__*/_react.default.cloneElement(child, {})) : ( /*#__PURE__*/_react.default.createElement(_Select.default, {
    onSelectClick: onSelectClick,
    items: items,
    type: type,
    size: size,
    isSplit: true,
    yPosition: selectPosition,
    xPosition: "right",
    disabled: disabled,
    hideSearch: hideSearch,
    onOpen: onOpen
  })))));
};
Button.propTypes = {
  disabled: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['small', 'large', 'medium']),
  onClick: _propTypes.default.func.isRequired,
  label: _propTypes.default.string,
  type: _propTypes.default.oneOf(['primary', 'secondary', 'text', 'error', 'danger', 'orange']),
  isSplit: _propTypes.default.bool,
  isSelect: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  hasIconOnly: _propTypes.default.bool,
  textToLeft: _propTypes.default.bool,
  icon: _propTypes.default.node,
  iconEnd: _propTypes.default.bool,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    title: _propTypes.default.string
  })),
  children: _propTypes.default.element,
  selectPosition: _propTypes.default.oneOf(['top', 'bottom']),
  onSelectClick: _propTypes.default.func,
  fullWidth: _propTypes.default.bool,
  tooltip: _propTypes.default.string,
  ref: _propTypes.default.node,
  buttonRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.instanceOf(Element)
  })]),
  hideSearch: _propTypes.default.bool,
  className: _propTypes.default.string,
  onOpen: _propTypes.default.func
};
Button.defaultProps = {
  disabled: false,
  isSplit: undefined,
  loading: false,
  size: 'medium',
  type: 'secondary',
  label: undefined,
  hasIconOnly: false,
  icon: undefined,
  iconEnd: false,
  isSelect: undefined,
  items: undefined,
  selectPosition: 'bottom',
  onSelectClick: undefined,
  fullWidth: false,
  tooltip: undefined,
  ref: undefined,
  buttonRef: undefined,
  hideSearch: true,
  className: undefined,
  children: undefined,
  onOpen: null
};
var _default = exports.default = Button;